import store from '@/store';
import { ref, watch } from '@vue/composition-api';
import Vue from 'vue';

export default function useApplicationsList() {
  const applicationListTable = ref([]);

  const tableColumns = [
    { text: 'Date', value: 'createdAt' },
    { text: 'Name', value: 'name', sortable: false },
    { text: 'Email', value: 'email', sortable: false },
    { text: 'Phone', value: 'number', sortable: false },
    { text: 'Website', value: 'website', sortable: false },
    { text: 'Company name', value: 'companyName', sortable: false },
    {
      text: 'Actions',
      value: 'actions',
      align: 'center',
      sortable: false,
    },
  ];

  const searchQuery = ref('');
  const applicationDateFilter = ref(null);
  const applicationDateModal = ref(null);
  const totalApplicationListTable = ref(0);
  const loading = ref(false);
  const options = ref({
    sortBy: ['createdAt'],
    sortDesc: [true],
    page: 1,
    itemsPerPage: 15,
  });

  // fetch data
  const fetchApplications = () => {
    loading.value = true;

    store
      .dispatch('application/fetchApplications', {
        q: searchQuery.value,
        applicationDate: applicationDateFilter.value,
        sortBy: options.value.sortBy[0],
        sortDesc: options.value.sortDesc[0],
        page: options.value.page,
        itemsPerPage: options.value.itemsPerPage,
      })
      .then(response => {
        applicationListTable.value = response.data.data;
        totalApplicationListTable.value = response.data.totalCount;
      })
      .catch(() => {
        Vue.notify({
          type: 'error',
          title: 'Applications',
          text: 'Cannot fetch applications',
        });
      })
      .finally(() => loading.value = false);
  };

  watch([searchQuery, options, applicationDateFilter], () => {
    loading.value = true;
    fetchApplications();
  });

  return {
    applicationDateFilter,
    applicationDateModal,
    applicationListTable,
    tableColumns,
    searchQuery,
    totalApplicationListTable,
    loading,
    options,
    fetchApplications,
  };
}
